import { ApiBase } from "./ApiBase";
import { Group } from "typings";

export class GroupAPI extends ApiBase
{
    async getGroups(): Promise<Group[]>
    {
        const response = await this.fetch("group");
        return response.json();
    }
}


// WEBPACK FOOTER //
// ./src/services/group.ts